import { useSyncExternalStore } from "react";

export const TOKENS = {
  bg: "#ffffff",
  heading: "#861b68",
  body: "#000000",
  border: "#eeeeee",
  inputBorder: "#d9d9d9",
  muted: "#6b6b6b",
  gradient: "linear-gradient(135deg, #861b68, #a32480)",
  gradientShadow: "0 12px 30px #861b684d",
  radiusBtn: "28px",
  radiusCard: "20px",
  radiusInput: "14px",
  radiusOverlay: "24px",
  fontPrimary: "'Google Sans', sans-serif",
  fontSerif: "'PT Serif', serif",
  fontDisplay: "'Playfair Display', serif",
  maxWidth: "1400px",
};

export const VISIBILITY = { ALL: "all", SELECTED: "selected" };

export const VISIBILITY_OPTIONS = [
  {
    value: VISIBILITY.ALL,
    label: "View All",
    description: "Everyone in the community can view this advertisement.",
  },
  {
    value: VISIBILITY.SELECTED,
    label: "View Selected People",
    description: "Choose specific people who can view this advertisement.",
  },
];

export const EDIT_WINDOW_MS = 8 * 60 * 60 * 1000;
export const UNLOCK_PRICE_INR = 500;
export const FREE_VIEWER_COUNT = 4;
export const ADS_PER_PAGE = 4;

export const CURRENT_USER_ID = 1;

export const FALLBACK_AD_IMAGE =
  "https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?auto=format&fit=crop&w=1200&q=80";

export const MOCK_MEMBERS = [
  { id: 1, name: "Rahul Mehta", designation: "Managing Director", company: "ABC Hospitality", location: "Delhi", avatar: "RM", email: "rahul.mehta@example.com" },
  { id: 2, name: "Priya Sharma", designation: "Hotel Manager", company: "The Grand Palace", location: "Gurugram", avatar: "PS", email: "priya.sharma@example.com" },
  { id: 3, name: "Amit Verma", designation: "Operations Head", company: "Verma Resorts", location: "Noida", avatar: "AV", email: "amit.verma@example.com" },
  { id: 4, name: "Neha Kapoor", designation: "Event Consultant", company: "Kapoor Events", location: "Delhi", avatar: "NK", email: "neha.kapoor@example.com" },
  { id: 5, name: "Karan Malhotra", designation: "Business Development Lead", company: "Malhotra Group", location: "Gurugram", avatar: "KM", email: "karan.malhotra@example.com" },
  { id: 6, name: "Rohit Verma", designation: "Regional Manager", company: "Northline Hospitality", location: "Delhi", avatar: "RV", email: "rohit.verma@example.com" },
  { id: 7, name: "Sneha Kapoor", designation: "Guest Relations Director", company: "Kapoor Events", location: "Noida", avatar: "SK", email: "sneha.kapoor@example.com" },
  { id: 8, name: "Anjali Sharma", designation: "Marketing Head", company: "The Grand Palace", location: "Delhi", avatar: "AS", email: "anjali.sharma@example.com" },
  { id: 9, name: "Vikram Singh", designation: "Founder", company: "Singh Hospitality Ventures", location: "Faridabad", avatar: "VS", email: "vikram.singh@example.com" },
  { id: 10, name: "Ritu Nair", designation: "Partnerships Manager", company: "Nair Leisure Group", location: "Delhi", avatar: "RN", email: "ritu.nair@example.com" },
];

export const nowIso = () => new Date().toISOString();
export const hoursAgoIso = (h) => new Date(Date.now() - h * 60 * 60 * 1000).toISOString();

export const buildAd = (overrides) => {
  const createdAt = overrides.createdAt || nowIso();
  const editDeadline = new Date(new Date(createdAt).getTime() + EDIT_WINDOW_MS).toISOString();
  return {
    reactions: 0,
    comments: 0,
    views: 0,
    selectedPeople: [],
    visibility: VISIBILITY.ALL,
    viewerAccess: "locked",
    ...overrides,
    createdAt,
    editDeadline,
  };
};

export const INITIAL_ADVERTISEMENTS = [
  buildAd({
    id: 2,
    posterId: 2,
    posterName: "Priya Sharma",
    company: "The Grand Palace",
    title: "Seeking Banquet Event Coordinators",
    description:
      "The Grand Palace is expanding its events wing and is looking for experienced banquet coordinators for the upcoming wedding season across our Gurugram and Delhi properties.",
    image:
      "https://images.unsplash.com/photo-1519167758481-83f550bb49b3?auto=format&fit=crop&w=1200&q=80",
    visibility: VISIBILITY.SELECTED,
    selectedPeople: [1, 5, 9],
    reactions: 16,
    comments: 4,
    views: 76,
    createdAt: hoursAgoIso(5),
  }),
  buildAd({
    id: 3,
    posterId: 4,
    posterName: "Neha Kapoor",
    company: "Kapoor Events",
    title: "Corporate Event Vendors Needed",
    description:
      "Kapoor Events is putting together a preferred vendor list for large corporate conferences in Q4. We are especially interested in AV, catering and venue-decor partners.",
    image:
      "https://images.unsplash.com/photo-1519167758481-83f550bb49b3?auto=format&fit=crop&w=1200&q=80",
    visibility: VISIBILITY.ALL,
    reactions: 31,
    comments: 12,
    views: 204,
    createdAt: hoursAgoIso(10),
  }),
  buildAd({
    id: 4,
    posterId: 9,
    posterName: "Vikram Singh",
    company: "Singh Hospitality Ventures",
    title: "Investment Opportunity: Boutique Property in Delhi",
    description:
      "We are raising a small round for a boutique 24-key property near Connaught Place. Looking to connect with members interested in hospitality real estate.",
    image:
      "https://images.unsplash.com/photo-1445019980597-93fa8acb246c?auto=format&fit=crop&w=1200&q=80",
    visibility: VISIBILITY.ALL,
    reactions: 42,
    comments: 19,
    views: 310,
    createdAt: hoursAgoIso(30),
  }),
  buildAd({
    id: 5,
    posterId: 6,
    posterName: "Rohit Verma",
    company: "Northline Hospitality",
    title: "Hiring: Front Office Trainers",
    description:
      "Northline Hospitality is looking for experienced front office trainers to run a two-week onboarding program for a new property launch in Noida.",
    image:
      "https://images.unsplash.com/photo-1517840901100-8179e982acb7?auto=format&fit=crop&w=1200&q=80",
    visibility: VISIBILITY.ALL,
    reactions: 9,
    comments: 2,
    views: 58,
    createdAt: hoursAgoIso(48),
  }),
  buildAd({
    id: 6,
    posterId: 10,
    posterName: "Ritu Nair",
    company: "Nair Leisure Group",
    title: "Looking for F&B Concept Partners",
    description:
      "Nair Leisure Group is scouting for independent F&B concepts to bring into our upcoming lifestyle property. Open to rooftop, all-day dining and specialty cuisine concepts.",
    image:
      "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=1200&q=80",
    visibility: VISIBILITY.SELECTED,
    selectedPeople: [1, 2, 4],
    reactions: 21,
    comments: 6,
    views: 143,
    createdAt: hoursAgoIso(72),
  }),
];

export const MOCK_VIEWERS = {
  1: [
    { id: 2, name: "Priya Sharma", viewedAt: "2h" },
    { id: 3, name: "Amit Verma", viewedAt: "3h" },
    { id: 4, name: "Neha Kapoor", viewedAt: "4h" },
    { id: 5, name: "Karan Malhotra", viewedAt: "5h" },
    { id: 6, name: "Rohit Verma", viewedAt: "6h" },
    { id: 7, name: "Sneha Kapoor", viewedAt: "8h" },
    { id: 8, name: "Anjali Sharma", viewedAt: "9h" },
  ],
  2: [
    { id: 1, name: "Rahul Mehta", viewedAt: "1h" },
    { id: 3, name: "Amit Verma", viewedAt: "2h" },
    { id: 6, name: "Rohit Verma", viewedAt: "4h" },
    { id: 8, name: "Anjali Sharma", viewedAt: "5h" },
  ],
  3: [
    { id: 1, name: "Rahul Mehta", viewedAt: "1h" },
    { id: 2, name: "Priya Sharma", viewedAt: "2h" },
    { id: 5, name: "Karan Malhotra", viewedAt: "3h" },
    { id: 9, name: "Vikram Singh", viewedAt: "5h" },
    { id: 10, name: "Ritu Nair", viewedAt: "7h" },
  ],
  4: [
    { id: 2, name: "Priya Sharma", viewedAt: "3h" },
    { id: 4, name: "Neha Kapoor", viewedAt: "6h" },
    { id: 5, name: "Karan Malhotra", viewedAt: "9h" },
    { id: 7, name: "Sneha Kapoor", viewedAt: "12h" },
    { id: 8, name: "Anjali Sharma", viewedAt: "14h" },
    { id: 10, name: "Ritu Nair", viewedAt: "20h" },
  ],
  5: [
    { id: 1, name: "Rahul Mehta", viewedAt: "10h" },
    { id: 9, name: "Vikram Singh", viewedAt: "20h" },
  ],
  6: [
    { id: 1, name: "Rahul Mehta", viewedAt: "5h" },
    { id: 3, name: "Amit Verma", viewedAt: "10h" },
    { id: 5, name: "Karan Malhotra", viewedAt: "15h" },
    { id: 8, name: "Anjali Sharma", viewedAt: "30h" },
    { id: 9, name: "Vikram Singh", viewedAt: "40h" },
  ],
  101: [
    { id: 2, name: "Priya Sharma", viewedAt: "1h" },
    { id: 3, name: "Amit Verma", viewedAt: "2h" },
    { id: 4, name: "Neha Kapoor", viewedAt: "3h" },
    { id: 5, name: "Karan Malhotra", viewedAt: "4h" },
    { id: 6, name: "Rohit Verma", viewedAt: "5h" },
    { id: 7, name: "Sneha Kapoor", viewedAt: "7h" },
    { id: 8, name: "Anjali Sharma", viewedAt: "9h" },
    { id: 9, name: "Vikram Singh", viewedAt: "12h" },
    { id: 10, name: "Ritu Nair", viewedAt: "16h" },
    { id: 1, name: "Rahul Mehta", viewedAt: "20h" },
    { id: 11, name: "Rajesh Khanna", viewedAt: "24h" },
    { id: 12, name: "Pooja Gupta", viewedAt: "28h" },
  ],
  102: [
    { id: 1, name: "Rahul Mehta", viewedAt: "1h" },
    { id: 4, name: "Neha Kapoor", viewedAt: "3h" },
    { id: 6, name: "Rohit Verma", viewedAt: "5h" },
    { id: 9, name: "Vikram Singh", viewedAt: "8h" },
    { id: 10, name: "Ritu Nair", viewedAt: "12h" },
    { id: 3, name: "Amit Verma", viewedAt: "18h" },
    { id: 8, name: "Anjali Sharma", viewedAt: "24h" },
    { id: 7, name: "Sneha Kapoor", viewedAt: "30h" },
  ],
  103: [
    { id: 2, name: "Priya Sharma", viewedAt: "2h" },
    { id: 5, name: "Karan Malhotra", viewedAt: "4h" },
    { id: 8, name: "Anjali Sharma", viewedAt: "7h" },
    { id: 10, name: "Ritu Nair", viewedAt: "11h" },
    { id: 1, name: "Rahul Mehta", viewedAt: "15h" },
    { id: 9, name: "Vikram Singh", viewedAt: "20h" },
  ],
  104: [
    { id: 3, name: "Amit Verma", viewedAt: "1h" },
    { id: 6, name: "Rohit Verma", viewedAt: "2h" },
    { id: 9, name: "Vikram Singh", viewedAt: "5h" },
    { id: 10, name: "Ritu Nair", viewedAt: "9h" },
    { id: 2, name: "Priya Sharma", viewedAt: "14h" },
  ],
};

export const REACTION_TYPES = {
  LIKE: "like",
  CELEBRATE: "celebrate",
  SUPPORT: "support",
  LOVE: "love",
  INSIGHTFUL: "insightful",
  FUNNY: "funny",
};

export const REACTION_LABELS = {
  [REACTION_TYPES.LIKE]: "Like",
  [REACTION_TYPES.CELEBRATE]: "Celebrate",
  [REACTION_TYPES.SUPPORT]: "Support",
  [REACTION_TYPES.LOVE]: "Love",
  [REACTION_TYPES.INSIGHTFUL]: "Insightful",
  [REACTION_TYPES.FUNNY]: "Funny",
};

// Icon (emoji) shown for each reaction type
export const REACTION_ICONS = {
  [REACTION_TYPES.CELEBRATE]: "👏", // Claps (Celebrate)
  [REACTION_TYPES.SUPPORT]: "🤝", // Support / handshake
  [REACTION_TYPES.LOVE]: "❤️", // Love
  [REACTION_TYPES.INSIGHTFUL]: "💡", // Insightful (bulb)
  [REACTION_TYPES.FUNNY]: "😂", // Funny
};

export const MOCK_REACTIONS_BY_AD = {
  1: [
    { id: "r1-1", memberId: 2, name: "Priya Sharma", type: REACTION_TYPES.LIKE, time: "1h" },
    { id: "r1-2", memberId: 3, name: "Amit Verma", type: REACTION_TYPES.CELEBRATE, time: "2h" },
    { id: "r1-3", memberId: 5, name: "Karan Malhotra", type: REACTION_TYPES.SUPPORT, time: "3h" },
    { id: "r1-4", memberId: 6, name: "Rohit Verma", type: REACTION_TYPES.LOVE, time: "4h" },
    { id: "r1-5", memberId: 7, name: "Sneha Kapoor", type: REACTION_TYPES.INSIGHTFUL, time: "5h" },
    { id: "r1-6", memberId: 8, name: "Anjali Sharma", type: REACTION_TYPES.FUNNY, time: "6h" },
    { id: "r1-7", memberId: 9, name: "Vikram Singh", type: REACTION_TYPES.LIKE, time: "8h" },
    { id: "r1-8", memberId: 10, name: "Ritu Nair", type: REACTION_TYPES.LOVE, time: "9h" },
  ],
  2: [
    { id: "r2-1", memberId: 1, name: "Rahul Mehta", type: REACTION_TYPES.LIKE, time: "1h" },
    { id: "r2-2", memberId: 3, name: "Amit Verma", type: REACTION_TYPES.SUPPORT, time: "2h" },
    { id: "r2-3", memberId: 6, name: "Rohit Verma", type: REACTION_TYPES.INSIGHTFUL, time: "4h" },
    { id: "r2-4", memberId: 8, name: "Anjali Sharma", type: REACTION_TYPES.LOVE, time: "5h" },
  ],
  3: [
    { id: "r3-1", memberId: 1, name: "Rahul Mehta", type: REACTION_TYPES.CELEBRATE, time: "1h" },
    { id: "r3-2", memberId: 2, name: "Priya Sharma", type: REACTION_TYPES.LIKE, time: "2h" },
    { id: "r3-3", memberId: 5, name: "Karan Malhotra", type: REACTION_TYPES.FUNNY, time: "3h" },
    { id: "r3-4", memberId: 9, name: "Vikram Singh", type: REACTION_TYPES.SUPPORT, time: "5h" },
    { id: "r3-5", memberId: 10, name: "Ritu Nair", type: REACTION_TYPES.LOVE, time: "7h" },
  ],
  4: [
    { id: "r4-1", memberId: 2, name: "Priya Sharma", type: REACTION_TYPES.INSIGHTFUL, time: "3h" },
    { id: "r4-2", memberId: 4, name: "Neha Kapoor", type: REACTION_TYPES.LIKE, time: "6h" },
    { id: "r4-3", memberId: 5, name: "Karan Malhotra", type: REACTION_TYPES.LIKE, time: "9h" },
    { id: "r4-4", memberId: 7, name: "Sneha Kapoor", type: REACTION_TYPES.SUPPORT, time: "12h" },
    { id: "r4-5", memberId: 8, name: "Anjali Sharma", type: REACTION_TYPES.CELEBRATE, time: "14h" },
    { id: "r4-6", memberId: 10, name: "Ritu Nair", type: REACTION_TYPES.LOVE, time: "20h" },
  ],
  5: [
    { id: "r5-1", memberId: 1, name: "Rahul Mehta", type: REACTION_TYPES.LIKE, time: "10h" },
    { id: "r5-2", memberId: 9, name: "Vikram Singh", type: REACTION_TYPES.LOVE, time: "20h" },
  ],
  6: [
    { id: "r6-1", memberId: 1, name: "Rahul Mehta", type: REACTION_TYPES.SUPPORT, time: "5h" },
    { id: "r6-2", memberId: 3, name: "Amit Verma", type: REACTION_TYPES.LIKE, time: "10h" },
    { id: "r6-3", memberId: 5, name: "Karan Malhotra", type: REACTION_TYPES.FUNNY, time: "15h" },
    { id: "r6-4", memberId: 8, name: "Anjali Sharma", type: REACTION_TYPES.INSIGHTFUL, time: "30h" },
    { id: "r6-5", memberId: 9, name: "Vikram Singh", type: REACTION_TYPES.LOVE, time: "40h" },
  ],
};

export const MOCK_REACTIONS_BY_POST = {
  901: [
    { id: "p901-1", memberId: 1, name: "Rahul Mehta", type: REACTION_TYPES.CELEBRATE, time: "1h" },
    { id: "p901-2", memberId: 3, name: "Amit Verma", type: REACTION_TYPES.LIKE, time: "2h" },
    { id: "p901-3", memberId: 6, name: "Rohit Verma", type: REACTION_TYPES.LOVE, time: "3h" },
  ],
  902: [
    { id: "p902-1", memberId: 1, name: "Rahul Mehta", type: REACTION_TYPES.LIKE, time: "4h" },
    { id: "p902-2", memberId: 8, name: "Anjali Sharma", type: REACTION_TYPES.SUPPORT, time: "6h" },
    { id: "p902-3", memberId: 10, name: "Ritu Nair", type: REACTION_TYPES.INSIGHTFUL, time: "8h" },
  ],
  903: [
    { id: "p903-1", memberId: 2, name: "Priya Sharma", type: REACTION_TYPES.CELEBRATE, time: "5h" },
    { id: "p903-2", memberId: 5, name: "Karan Malhotra", type: REACTION_TYPES.LIKE, time: "7h" },
  ],
  904: [
    { id: "p904-1", memberId: 1, name: "Rahul Mehta", type: REACTION_TYPES.LOVE, time: "1h" },
    { id: "p904-2", memberId: 9, name: "Vikram Singh", type: REACTION_TYPES.LIKE, time: "2h" },
    { id: "p904-3", memberId: 3, name: "Amit Verma", type: REACTION_TYPES.SUPPORT, time: "3h" },
  ],
  101: [
    { id: "p101-1", memberId: 2, name: "Priya Sharma", type: REACTION_TYPES.LIKE, time: "1h" },
    { id: "p101-2", memberId: 3, name: "Amit Verma", type: REACTION_TYPES.CELEBRATE, time: "2h" },
    { id: "p101-3", memberId: 4, name: "Neha Kapoor", type: REACTION_TYPES.SUPPORT, time: "3h" },
    { id: "p101-4", memberId: 5, name: "Karan Malhotra", type: REACTION_TYPES.LIKE, time: "4h" },
    { id: "p101-5", memberId: 6, name: "Rohit Verma", type: REACTION_TYPES.INSIGHTFUL, time: "5h" },
    { id: "p101-6", memberId: 7, name: "Sneha Kapoor", type: REACTION_TYPES.LOVE, time: "7h" },
    { id: "p101-7", memberId: 8, name: "Anjali Sharma", type: REACTION_TYPES.FUNNY, time: "9h" },
    { id: "p101-8", memberId: 9, name: "Vikram Singh", type: REACTION_TYPES.LIKE, time: "12h" },
    { id: "p101-9", memberId: 10, name: "Ritu Nair", type: REACTION_TYPES.SUPPORT, time: "16h" },
    { id: "p101-10", memberId: 1, name: "Rahul Mehta", type: REACTION_TYPES.CELEBRATE, time: "20h" },
    { id: "p101-11", memberId: 5, name: "Karan Malhotra", type: REACTION_TYPES.INSIGHTFUL, time: "26h" },
    { id: "p101-12", memberId: 7, name: "Sneha Kapoor", type: REACTION_TYPES.LIKE, time: "32h" },
  ],
  102: [
    { id: "p102-1", memberId: 1, name: "Rahul Mehta", type: REACTION_TYPES.LIKE, time: "1h" },
    { id: "p102-2", memberId: 4, name: "Neha Kapoor", type: REACTION_TYPES.CELEBRATE, time: "3h" },
    { id: "p102-3", memberId: 6, name: "Rohit Verma", type: REACTION_TYPES.LOVE, time: "5h" },
    { id: "p102-4", memberId: 9, name: "Vikram Singh", type: REACTION_TYPES.SUPPORT, time: "8h" },
    { id: "p102-5", memberId: 10, name: "Ritu Nair", type: REACTION_TYPES.INSIGHTFUL, time: "12h" },
    { id: "p102-6", memberId: 3, name: "Amit Verma", type: REACTION_TYPES.LIKE, time: "18h" },
    { id: "p102-7", memberId: 8, name: "Anjali Sharma", type: REACTION_TYPES.FUNNY, time: "24h" },
  ],
  103: [
    { id: "p103-1", memberId: 2, name: "Priya Sharma", type: REACTION_TYPES.SUPPORT, time: "2h" },
    { id: "p103-2", memberId: 5, name: "Karan Malhotra", type: REACTION_TYPES.LIKE, time: "4h" },
    { id: "p103-3", memberId: 8, name: "Anjali Sharma", type: REACTION_TYPES.INSIGHTFUL, time: "7h" },
    { id: "p103-4", memberId: 10, name: "Ritu Nair", type: REACTION_TYPES.CELEBRATE, time: "11h" },
    { id: "p103-5", memberId: 1, name: "Rahul Mehta", type: REACTION_TYPES.LIKE, time: "15h" },
  ],
  104: [
    { id: "p104-1", memberId: 3, name: "Amit Verma", type: REACTION_TYPES.LOVE, time: "1h" },
    { id: "p104-2", memberId: 6, name: "Rohit Verma", type: REACTION_TYPES.LIKE, time: "2h" },
    { id: "p104-3", memberId: 9, name: "Vikram Singh", type: REACTION_TYPES.INSIGHTFUL, time: "5h" },
    { id: "p104-4", memberId: 10, name: "Ritu Nair", type: REACTION_TYPES.SUPPORT, time: "9h" },
  ],
};

export const MOCK_COMMENTS_BY_AD = {
1: [
    { id: "c1-1", memberId: 2, name: "Priya Sharma", text: "This is exactly what we have been looking for. Sharing with our board.", timestamp: "1h" },
    { id: "c1-2", memberId: 3, name: "Amit Verma", text: "We have two mid-format properties in Gurugram. Happy to connect.", timestamp: "2h" },
    { id: "c1-3", memberId: 8, name: "Anjali Sharma", text: "Interested in the revenue-share model. Can you share more details?", timestamp: "4h" },
    { id: "c1-4", memberId: 5, name: "Karan Malhotra", text: "Great opportunity for regional partners.", timestamp: "6h" },
    { id: "c1-5", memberId: 1, name: "Rahul Mehta", text: "Let us schedule a call this week.", timestamp: "3h" },
    { id: "c1-6", memberId: 6, name: "Rohit Verma", text: "Sent you a connection request.", timestamp: "5h" },
    { id: "c1-7", memberId: 4, name: "Neha Kapoor", text: "We manage similar properties, keen to discuss.", timestamp: "7h" },
    { id: "c1-8", memberId: 9, name: "Vikram Singh", text: "AV and event support available.", timestamp: "8h" },
    { id: "c1-9", memberId: 7, name: "Sneha Kapoor", text: "Good margins on paper, want details.", timestamp: "9h" },
    { id: "c1-10", memberId: 10, name: "Ritu Nair", text: "Confirming our interest for the region.", timestamp: "10h" },
    { id: "c1-11", memberId: 2, name: "Priya Sharma", text: "Sharing deck with the investment team.", timestamp: "11h" },
    { id: "c1-12", memberId: 3, name: "Amit Verma", text: "Also exploring two more locations.", timestamp: "12h" },
    { id: "c1-13", memberId: 5, name: "Karan Malhotra", text: "Let us connect on partnership terms.", timestamp: "13h" },
  ],
  2: [
    { id: "c2-1", memberId: 1, name: "Rahul Mehta", text: "We have experienced coordinators available.", timestamp: "1h" },
    { id: "c2-2", memberId: 6, name: "Rohit Verma", text: "Sent you a message about this.", timestamp: "3h" },
  ],
  3: [
    { id: "c3-1", memberId: 5, name: "Karan Malhotra", text: "Our catering team would be a great fit.", timestamp: "2h" },
    { id: "c3-2", memberId: 9, name: "Vikram Singh", text: "AV vendor list ready to share.", timestamp: "5h" },
    { id: "c3-3", memberId: 10, name: "Ritu Nair", text: "Count us in for venue decor.", timestamp: "8h" },
  ],
  4: [
    { id: "c4-1", memberId: 8, name: "Anjali Sharma", text: "Would love to know the ticket size.", timestamp: "4h" },
    { id: "c4-2", memberId: 2, name: "Priya Sharma", text: "Delhi property sounds interesting.", timestamp: "10h" },
  ],
  5: [],
  6: [
    { id: "c6-1", memberId: 2, name: "Priya Sharma", text: "Open to a rooftop discussion.", timestamp: "2h" },
  ],
};

export const MOCK_COMMENTS_BY_POST = {
  901: [
    { id: "pc901-1", memberId: 4, name: "Neha Kapoor", text: "The rooftop sounds fantastic, counting down!", timestamp: "2h" },
    { id: "pc901-2", memberId: 1, name: "Rahul Mehta", text: "Excited to see this launch.", timestamp: "1h" },
  ],
  902: [
    { id: "pc902-1", memberId: 9, name: "Vikram Singh", text: "I will be there, looking forward to it.", timestamp: "6h" },
    { id: "pc902-2", memberId: 2, name: "Priya Sharma", text: "Can you share the agenda?", timestamp: "2h" },
    { id: "pc902-3", memberId: 3, name: "Amit Verma", text: "Our operations head is attending too.", timestamp: "1h" },
  ],
  903: [
    { id: "pc903-1", memberId: 6, name: "Rohit Verma", text: "Great topic, will join the session.", timestamp: "12h" },
    { id: "pc903-2", memberId: 10, name: "Ritu Nair", text: "Live sessions are always useful.", timestamp: "8h" },
    { id: "pc903-3", memberId: 1, name: "Rahul Mehta", text: "Sharing this with my events team, we are in.", timestamp: "7h" },
    { id: "pc903-4", memberId: 2, name: "Priya Sharma", text: "Count on our venue booking too.", timestamp: "6h" },
    { id: "pc903-5", memberId: 3, name: "Amit Verma", text: "Our decor team will coordinate.", timestamp: "6h" },
    { id: "pc903-6", memberId: 4, name: "Neha Kapoor", text: "Looks promising, added to calendar.", timestamp: "5h" },
    { id: "pc903-7", memberId: 5, name: "Karan Malhotra", text: "Great initiative for sustainability.", timestamp: "5h" },
    { id: "pc903-8", memberId: 7, name: "Sneha Kapoor", text: "Will attend, thanks for organizing.", timestamp: "4h" },
    { id: "pc903-9", memberId: 8, name: "Anjali Sharma", text: "Interested in the speakers lineup.", timestamp: "4h" },
    { id: "pc903-10", memberId: 9, name: "Vikram Singh", text: "Our photographer can cover the event.", timestamp: "3h" },
    { id: "pc903-11", memberId: 6, name: "Rohit Verma", text: "Also sharing the agenda with our team.", timestamp: "3h" },
    { id: "pc903-12", memberId: 1, name: "Rahul Mehta", text: "Any partner slots still available?", timestamp: "2h" },
    { id: "pc903-13", memberId: 10, name: "Ritu Nair", text: "Yes, would love to collaborate.", timestamp: "1h" },
  ],
  904: [
    { id: "pc904-1", memberId: 1, name: "Rahul Mehta", text: "Count me in for Friday.", timestamp: "20h" },
    { id: "pc904-2", memberId: 5, name: "Karan Malhotra", text: "Will bring the regional team along.", timestamp: "14h" },
  ],
  101: [
    { id: "pc101-1", memberId: 7, name: "Sneha Kapoor", text: "We may be interested. Can we discuss offline?", timestamp: "1h" },
    { id: "pc101-2", memberId: 6, name: "Rohit Verma", text: "Shared internally with our expansion team.", timestamp: "3h" },
    { id: "pc101-3", memberId: 10, name: "Ritu Nair", text: "Revenue-share structure looks interesting.", timestamp: "5h" },
  ],
  102: [
    { id: "pc102-1", memberId: 8, name: "Anjali Sharma", text: "We have banquet coordinators who fit this.", timestamp: "2h" },
    { id: "pc102-2", memberId: 1, name: "Rahul Mehta", text: "Reached out via message.", timestamp: "4h" },
  ],
  103: [
    { id: "pc103-1", memberId: 5, name: "Karan Malhotra", text: "Our catering team would be a great fit.", timestamp: "6h" },
    { id: "pc103-2", memberId: 9, name: "Vikram Singh", text: "AV vendor list ready to share.", timestamp: "8h" },
    { id: "pc103-3", memberId: 10, name: "Ritu Nair", text: "Count us in for venue decor.", timestamp: "9h" },
  ],
  104: [
    { id: "pc104-1", memberId: 2, name: "Priya Sharma", text: "This could suit our investors network.", timestamp: "4h" },
    { id: "pc104-2", memberId: 4, name: "Neha Kapoor", text: "Happy to introduce potential partners.", timestamp: "7h" },
  ],
};

export const MOCK_REACTIONS = [
  { id: 1, name: "Amit Verma", text: "Interested!" },
  { id: 2, name: "Priya Sharma", text: "This looks great!" },
  { id: 3, name: "Karan Malhotra", text: "Can you share more details?" },
  { id: 4, name: "Sneha Kapoor", text: "Sent you a message about this." },
];

export function formatTimeAgo(iso) {
  const diffMs = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return "now";
  if (mins < 60) return `${mins}m`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h`;
  const days = Math.floor(hrs / 24);
  if (days < 30) return `${days}d`;
  const months = Math.floor(days / 30);
  return `${months}mo`;
}

export function getAdvertisementEditState(postedAt, currentTime = new Date()) {
  const posted = new Date(postedAt).getTime();
  const now = new Date(currentTime).getTime();
  const elapsed = now - posted;
  return elapsed < EDIT_WINDOW_MS ? "editable" : "locked";
}

export function getRemainingEditTime(postedAt, currentTime = new Date()) {
  const posted = new Date(postedAt).getTime();
  const now = new Date(currentTime).getTime();
  const remainingMs = Math.max(0, posted + EDIT_WINDOW_MS - now);
  const totalMinutes = Math.floor(remainingMs / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return { hours, minutes, remainingMs };
}

export function formatCountdown(postedAt, currentTime = new Date()) {
  const { hours, minutes } = getRemainingEditTime(postedAt, currentTime);
  return `${hours} hour${hours === 1 ? "" : "s"} ${minutes} minute${minutes === 1 ? "" : "s"} remaining`;
}

export function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function getMemberById(id) {
  return MOCK_MEMBERS.find((m) => m.id === id);
}

/* ============================================================
   Community Posts & Events
   ============================================================ */

export const POST_VISIBILITY = { ANYONE: "anyone", CONNECTIONS: "connections" };
export const COMMENT_PERMISSION = { ANYONE: "anyone", CONNECTIONS: "connections", OFF: "off" };
export const EVENT_TYPE = { ONLINE: "online", IN_PERSON: "in_person" };

export const POST_MAX_PHOTOS = 5;
export const POST_MAX_MEDIA = 5;
export const POST_MAX_VIDEOS = 1;
export const POST_MAX_TEXT = 1000;
export const EVENT_NAME_MAX = 75;
export const EVENT_TITLE_MAX = 100;
export const EVENT_DESC_MAX = 1000;
export const COMMENT_MAX_WORDS = 1000;
export const EVENT_LINK_MAX = 1000;
export const EVENT_WORD_MAX = 100;
export const POST_TITLE_MAX_WORDS = 100;
export const EVENT_COVER_MIN_WIDTH = 480;
export const EVENT_COVER_MAX_MEDIA = 5;
export const EVENT_COVER_MAX_VIDEOS = 1;

export const TIMEZONES = [
  "(GMT+05:30) India Standard Time (IST)",
  "(GMT+00:00) Greenwich Mean Time (GMT)",
  "(GMT-05:00) Eastern Time (ET)",
  "(GMT-08:00) Pacific Time (PT)",
  "(GMT+01:00) Central European Time (CET)",
  "(GMT+08:00) Singapore Time (SGT)",
  "(GMT+09:00) Japan Standard Time (JST)",
  "(GMT+04:00) Gulf Standard Time (GST)",
  "(GMT+10:00) Australian Eastern Time (AEST)",
];

export const buildEvent = (overrides = {}) => ({
  id: null,
  coverPhotos: [],
  coverVideo: "",
  coverVideoIndex: -1,
  coverVideoEdits: null,
  coverItems: [],
  youtube: [],
  coverThumbnail: null,
  coverThumbnails: [],
  eventType: EVENT_TYPE.ONLINE,
  name: "",
  nameColor: "#000000",
  nameSize: 20,
  nameWeight: 700,
  nameItalic: false,
  nameUnderline: false,
  nameFontFamily: "auto",
  titleColor: "#000000",
  titleSize: 20,
  titleWeight: 700,
  titleItalic: false,
  titleUnderline: false,
  titleFontFamily: "auto",
  timezone: TIMEZONES[0],
  startDate: "",
  startTime: "",
  hasEndDate: false,
  endDate: "",
  endTime: "",
  address: "",
  venue: "",
  title: "",
  description: "",
  descColor: "#1a1a1a",
  descSize: 14,
  descWeight: 400,
  descItalic: false,
  descUnderline: false,
  descFontFamily: "auto",
  gif: null,
  externalLink: "",
  visibility: POST_VISIBILITY.ANYONE,
  commentPermission: COMMENT_PERMISSION.ANYONE,
  emojiEnabled: true,
  hideLikes: false,
  hideLikeCount: false,
  hideComments: false,
  hideCommentCount: false,
  socials: [],
  taggedPeople: [],
  ...overrides,
});

export const buildPost = (overrides = {}) => ({
  id: null,
  posterId: CURRENT_USER_ID,
  posterName: getMemberById(CURRENT_USER_ID).name,
  company: getMemberById(CURRENT_USER_ID).company,
  avatar: getMemberById(CURRENT_USER_ID).avatar,
  text: "",
  textColor: "#1a1a1a",
  textSize: 16,
  textWeight: 400,
  textItalic: false,
  textUnderline: false,
  title: "",
  titleColor: "#000000",
  titleSize: 20,
  titleWeight: 600,
  titleItalic: false,
  titleUnderline: false,
  visibility: POST_VISIBILITY.ANYONE,
  commentPermission: COMMENT_PERMISSION.ANYONE,
  emojiEnabled: true,
  hideLikes: false,
  hideComments: false,
  hideLikeCount: false,
  hideCommentCount: false,
  photos: [],
  video: null,
  videoEdits: [],
  videoThumbnail: null,
  videoThumbnails: [],
  gif: null,
  youtube: null,
  event: null,
  taggedPeople: [],
  location: "",
  createdAt: nowIso(),
  ...overrides,
});

const SAMPLE_SOCIAL_VALUES = {
  whatsapp: "+91 555 010 010",
  linkedin: "linkedin.com/in/sample",
  facebook: "facebook.com/sample",
  gmail: "sample@gmail.com",
  twitter: "sample",
  youtube: "youtube.com/@sample",
};

const sampleSocials = (ids) =>
  ids.map((id) => ({
    id,
    value: SAMPLE_SOCIAL_VALUES[id] || "sample",
  }));

/* Bump this whenever INITIAL_POSTS (or any other seed data the store mines)
   changes, so running apps refresh their shared state instead of keeping stale
   snapshots captured before the edit. */
export const COMMUNITY_SEED_VERSION = 3;

export const INITIAL_POSTS = [
  buildPost({
    id: 901,
    posterId: 2,
    posterName: "Priya Sharma",
    company: "The Grand Palace",
    avatar: "PS",
    text: "Excited to announce our new rooftop dining experience opening this festive season! Stay tuned for details. 🎉",
    visibility: POST_VISIBILITY.ANYONE,
    commentPermission: COMMENT_PERMISSION.ANYONE,
    socials: sampleSocials(["whatsapp", "linkedin", "youtube"]),
    createdAt: hoursAgoIso(3),
  }),
  buildPost({
    id: 902,
    posterId: 5,
    posterName: "Karan Malhotra",
    company: "Malhotra Group",
    avatar: "KM",
    text: "Looking forward to connecting with fellow hospitality leaders at the upcoming industry summit. Who else is attending?",
    visibility: POST_VISIBILITY.CONNECTIONS,
    commentPermission: COMMENT_PERMISSION.CONNECTIONS,
    socials: sampleSocials(["whatsapp", "linkedin", "facebook", "gmail", "twitter", "youtube"]),
    createdAt: hoursAgoIso(9),
  }),
  buildPost({
    id: 903,
    posterId: 4,
    posterName: "Neha Kapoor",
    company: "Kapoor Events",
    avatar: "NK",
    text: "Hosting a live session on sustainable event planning this Thursday. Mark your calendars! 📅",
event: buildEvent({
      id: 903,
      coverPhotos: [
        "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?auto=format&fit=crop&w=1200&q=80",
      ],
      eventType: EVENT_TYPE.ONLINE,
      name: "Sustainable Event Planning Live Session",
      timezone: TIMEZONES[0],
      startDate: "2026-09-05",
      startTime: "16:00",
      hasEndDate: true,
      endDate: "2026-09-05",
      endTime: "17:30",
      externalLink: "https://meet.example.com/sustainable-events",
    }),
    visibility: POST_VISIBILITY.ANYONE,
    commentPermission: COMMENT_PERMISSION.ANYONE,
    socials: sampleSocials(["whatsapp", "gmail"]),
    createdAt: hoursAgoIso(20),
  }),
  buildPost({
    id: 904,
    posterId: 7,
    posterName: "Sneha Kapoor",
    company: "The Grand Palace",
    avatar: "SK",
    text: "Join us for an exclusive networking dinner this Friday at the Grand Palace ballroom.",
    event: buildEvent({
      id: 904,
      coverPhotos: [
        "https://images.unsplash.com/photo-1519671482749-fd09be7ccebf?auto=format&fit=crop&w=1200&q=80",
      ],
      eventType: EVENT_TYPE.IN_PERSON,
      name: "Hospitality Leaders Networking Dinner",
      timezone: TIMEZONES[0],
      startDate: "2026-09-06",
      startTime: "19:00",
      hasEndDate: false,
      venue: "The Grand Palace Ballroom",
      address: "Connaught Place, New Delhi",
    }),
    visibility: POST_VISIBILITY.ANYONE,
    commentPermission: COMMENT_PERMISSION.ANYONE,
    socials: sampleSocials(["linkedin", "facebook", "twitter"]),
    createdAt: hoursAgoIso(30),
  }),
  buildPost({
    id: 101,
    posterId: 1,
    posterName: "Rahul Mehta",
    company: "ABC Hospitality",
    avatar: "RM",
    text: "We are looking for experienced hotel management partners for upcoming projects in Delhi NCR. Ideal partners have prior experience running mid to large-format properties and are comfortable with a revenue-share structure.",
    photos: [
      "https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=1200&q=80",
    ],
    title: "Looking for Hotel Management Partners",
    socials: sampleSocials(["whatsapp", "linkedin", "facebook", "gmail", "twitter", "youtube"]),
    createdAt: hoursAgoIso(2),
  }),
  buildPost({
    id: 110,
    posterId: 1,
    posterName: "Rahul Mehta",
    company: "ABC Hospitality",
    avatar: "RM",
    text: "Excited to share that ABC Hospitality has signed a mid-scale lifestyle property in Chandigarh. We will be hiring across departments in the coming weeks — stay tuned for openings!",
    photos: [
      "https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?auto=format&fit=crop&w=1200&q=80",
    ],
    title: "New Property Signed in Chandigarh",
    location: "Sector 17, Chandigarh",
    socials: sampleSocials(["whatsapp", "linkedin", "facebook", "gmail", "twitter", "youtube"]),
    createdAt: hoursAgoIso(1),
  }),
  buildPost({
    id: 111,
    posterId: 1,
    posterName: "Rahul Mehta",
    company: "ABC Hospitality",
    avatar: "RM",
    text: "Quick walkthrough of The Royale Suite at our Connaught Place property. Designed in partnership with a leading interior studio — feedback welcome.",
    photos: [],
    video: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4",
    videoThumbnail: "https://images.unsplash.com/photo-1590490360182-c33d57733427?auto=format&fit=crop&w=1200&q=80",
    title: "Inside The Royale Suite — Video Tour",
    location: "Connaught Place, New Delhi",
    socials: sampleSocials(["whatsapp", "youtube"]),
    createdAt: hoursAgoIso(4),
  }),
  buildPost({
    id: 112,
    posterId: 1,
    posterName: "Rahul Mehta",
    company: "ABC Hospitality",
    avatar: "RM",
    text: "Our Noida property just crossed a 92% occupancy weekend! Huge thank you to the team. 🎉",
    gif: {
      preview: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=1200&q=80",
      media: "https://media.giphy.com/media/26tPplGWjN0xLybiU/giphy.gif",
    },
    title: "Record Weekend at Noida",
    socials: sampleSocials(["whatsapp", "linkedin", "facebook"]),
    createdAt: hoursAgoIso(6),
  }),
  buildPost({
    id: 113,
    posterId: 1,
    posterName: "Rahul Mehta",
    company: "ABC Hospitality",
    avatar: "RM",
    text: "Quick networking ask — who would you recommend for large-format banana leaf catering in Delhi NCR? Need someone reliable for a 600-pax corporate dinner next month.",
    visibility: POST_VISIBILITY.ANYONE,
    commentPermission: COMMENT_PERMISSION.ANYONE,
    socials: sampleSocials(["whatsapp", "gmail"]),
    createdAt: hoursAgoIso(11),
  }),
  buildPost({
    id: 114,
    posterId: 1,
    posterName: "Rahul Mehta",
    company: "ABC Hospitality",
    avatar: "RM",
    text: "Renovation complete at The Grand Pavilion. New rooftop, redesigned lobby and updated banquet floors — walk-ins for site visits are welcome all week.",
    photos: [
      "https://images.unsplash.com/photo-1445019980597-93fa8acb246c?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=1200&q=80",
    ],
    title: "The Grand Pavilion Renovation is Live",
    location: "Aerocity, New Delhi",
    socials: sampleSocials(["whatsapp", "linkedin", "facebook", "gmail"]),
    createdAt: hoursAgoIso(15),
  }),
  buildPost({
    id: 115,
    posterId: 1,
    posterName: "Rahul Mehta",
    company: "ABC Hospitality",
    avatar: "RM",
    text: "Join us for an open networking mixer with Delhi NCR hospitality operators. Great opportunity to meet the IHN community in person.",
    event: buildEvent({
      id: 115,
      coverPhotos: [
        "https://images.unsplash.com/photo-1519671482749-fd09be7ccebf?auto=format&fit=crop&w=1200&q=80",
      ],
      eventType: EVENT_TYPE.IN_PERSON,
      name: "IHN Members Intro Mixer — New Delhi",
      timezone: TIMEZONES[0],
      startDate: "2026-09-15",
      startTime: "19:00",
      hasEndDate: false,
      venue: "The Ivory Lounge, ABC Hospitality",
      address: "Chanakyapuri, New Delhi",
      description: "An informal evening to meet fellow IHN hospitality members and exchange referrals.",
      externalLink: "https://events.example.com/ihn-intro-mixer",
    }),
    visibility: POST_VISIBILITY.ANYONE,
    commentPermission: COMMENT_PERMISSION.ANYONE,
    socials: sampleSocials(["whatsapp", "linkedin", "facebook", "twitter"]),
    createdAt: hoursAgoIso(22),
  }),
  buildPost({
    id: 116,
    posterId: 1,
    posterName: "Rahul Mehta",
    company: "ABC Hospitality",
    avatar: "RM",
    text: "Festive season partnership opportunity — we have banquet and rooftop space at our Connaught Place venue open for Q4 events. Looking for partner brands in catering, décor and AV.",
    photos: [
      "https://images.unsplash.com/photo-1519167758481-83f550bb49b3?auto=format&fit=crop&w=1200&q=80",
    ],
    title: "Q4 Event Space & Partner Brands",
    location: "Connaught Place, New Delhi",
    socials: sampleSocials(["whatsapp", "linkedin", "facebook", "gmail", "youtube"]),
    createdAt: hoursAgoIso(26),
  }),
  buildPost({
    id: 102,
    posterId: 2,
    posterName: "Priya Sharma",
    company: "The Grand Palace",
    avatar: "PS",
    text: "The Grand Palace is expanding its events wing and is looking for experienced banquet coordinators for the upcoming wedding season across our Gurugram and Delhi properties.",
    photos: [
      "https://images.unsplash.com/photo-1519167758481-83f550bb49b3?auto=format&fit=crop&w=1200&q=80",
    ],
    title: "Seeking Banquet Event Coordinators",
    socials: sampleSocials(["whatsapp", "gmail"]),
    createdAt: hoursAgoIso(5),
  }),
  buildPost({
    id: 103,
    posterId: 4,
    posterName: "Neha Kapoor",
    company: "Kapoor Events",
    avatar: "NK",
    text: "Kapoor Events is putting together a preferred vendor list for large corporate conferences in Q4. We are especially interested in AV, catering and venue-decor partners.",
    photos: [
      "https://images.unsplash.com/photo-1519167758481-83f550bb49b3?auto=format&fit=crop&w=1200&q=80",
    ],
    title: "Corporate Event Vendors Needed",
    socials: sampleSocials(["whatsapp", "linkedin", "youtube"]),
    createdAt: hoursAgoIso(10),
  }),
  buildPost({
    id: 104,
    posterId: 9,
    posterName: "Vikram Singh",
    company: "Singh Hospitality Ventures",
    avatar: "VS",
    text: "We are raising a small round for a boutique 24-key property near Connaught Place. Looking to connect with members interested in hospitality real estate.",
    photos: [
      "https://images.unsplash.com/photo-1445019980597-93fa8acb246c?auto=format&fit=crop&w=1200&q=80",
    ],
    title: "Investment Opportunity: Boutique Property in Delhi",
    socials: sampleSocials(["whatsapp", "linkedin", "facebook", "gmail", "twitter", "youtube"]),
    createdAt: hoursAgoIso(30),
  }),
  buildPost({
    id: 105,
    posterId: 6,
    posterName: "Rohit Verma",
    company: "Northline Hospitality",
    avatar: "RV",
    text: "Northline Hospitality is looking for experienced front office trainers to run a two-week onboarding program for a new property launch in Noida.",
    photos: [
      "https://images.unsplash.com/photo-1517840901100-8179e982acb7?auto=format&fit=crop&w=1200&q=80",
    ],
    title: "Hiring: Front Office Trainers",
    socials: sampleSocials(["whatsapp", "gmail"]),
    createdAt: hoursAgoIso(48),
  }),
  buildPost({
    id: 106,
    posterId: 10,
    posterName: "Ritu Nair",
    company: "Nair Leisure Group",
    avatar: "RN",
    text: "Nair Leisure Group is scouting for independent F&B concepts to bring into our upcoming lifestyle property. Open to rooftop, all-day dining and specialty cuisine concepts.",
    photos: [
      "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=1200&q=80",
    ],
    title: "Looking for F&B Concept Partners",
    socials: sampleSocials(["whatsapp", "linkedin", "youtube"]),
    createdAt: hoursAgoIso(72),
  }),
];

export function isValidUrl(value) {
  if (!value) return false;
  try {
    const url = new URL(value);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
}

export function formatDateLabel(date, time) {
  if (!date) return "";
  const d = new Date(`${date}T${time || "00:00"}:00`);
  if (isNaN(d.getTime())) return date;
  return d.toLocaleString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

export const REPORT_REASONS = [
  { id: "spam", label: "Spam" },
  { id: "harassment", label: "Harassment or bullying" },
  { id: "hate_speech", label: "Hate speech" },
  { id: "violence", label: "Violence or dangerous content" },
  { id: "misinformation", label: "False or misleading information" },
  { id: "ip_violation", label: "Intellectual property violation" },
  { id: "nudity", label: "Nudity or sexual content" },
  { id: "nc_imagery", label: "Nonconsensual intimate imagery" },
  { id: "scam", label: "Scam or fraud" },
  { id: "other", label: "Other" },
];

export const REPORT_OTHER_MAX = 1000;

/* ============================================================
   Community shared state store
   ============================================================ */

const buildInitialState = () => ({
  posts: INITIAL_POSTS,
  followingPosters: new Set(),
  savedPosts: new Set(),
  archivedPosts: new Set(),
  hiddenPosts: new Set(),
  hiddenLikeCounts: new Set(),
  hiddenCommentCounts: new Set(),
  likedPosts: new Map(),
});

let state = null;
let appliedVersion = null;
const listeners = new Set();

const notify = () => listeners.forEach((fn) => fn());

const ensureState = () => {
  if (!state || appliedVersion !== COMMUNITY_SEED_VERSION) {
    state = buildInitialState();
    appliedVersion = COMMUNITY_SEED_VERSION;
    notify();
  }
  return state;
};

export const getCommunityState = () => ensureState();

export const publishCommunityState = (next) => {
  state = next;
  appliedVersion = COMMUNITY_SEED_VERSION;
  notify();
};

export const updateCommunityState = (fn) => {
  publishCommunityState(typeof fn === "function" ? fn(ensureState()) : fn);
};

const subscribe = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

export const useCommunityState = () =>
  useSyncExternalStore(subscribe, getCommunityState, getCommunityState);
